/**
 * Season-Agnostic Constants
 *
 * Constants that remain the same across all seasons.
 * These values are not expected to change year-to-year.
 */

/**
 * Currency used for all pricing
 */
export const CURRENCY = 'usd' as const;

/**
 * Stripe configuration (non-sensitive)
 */
export const STRIPE_CONFIG = {
  publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  allowedParameters: [
    'lineItems',
    'mode',
    'successUrl',
    'cancelUrl',
    'customerEmail',
    'sessionId'
  ] as const
} as const;

/**
 * Application form field requirements (consistent across seasons)
 */
export const FORM_REQUIREMENTS = {
  portfolio: {
    minItems: 2,
    maxItems: 5,
    allowedAudioFormats: ['mp3', 'wav', 'flac', 'm4a'],
    allowedDocumentFormats: ['pdf'],
    maxFileSize: 50 * 1024 * 1024 // 50MB
  },
  personalInfo: {
    minAge: 16,
    maxAge: 35
  }
} as const;

/**
 * Program types available for application
 */
export const PROGRAM_TYPES = {
  FULL_SESSION: 'fullSession',
  SINGLE_SESSION: 'singleSession'
} as const;

/**
 * Application types
 */
export const APPLICATION_TYPES = {
  STUDENT: 'student',
  FELLOWSHIP: 'fellowship'
} as const;

/**
 * Session identifiers
 */
export const SESSION_IDS = {
  SESSION_1: 1,
  SESSION_2: 2
} as const;

/**
 * Contact information (consistent across seasons)
 */
export const CONTACT_INFO = {
  email: 'info@atlanticmusicfestival.org',
  phone: '+1 (207) 873-0000'
} as const;

/**
 * Social media handles (consistent across seasons)
 */
export const SOCIAL_MEDIA = {
  facebook: 'atlanticmusicfestival',
  instagram: 'atlanticmusicfest',
  twitter: 'atlanticmusicf',
  youtube: 'atlanticmusicfestival'
} as const;

/**
 * Time-related constants
 */
export const TIME_CONSTANTS = {
  MILLISECONDS_PER_DAY: 1000 * 60 * 60 * 24,
  SECONDS_PER_DAY: 60 * 60 * 24,
  SESSION_DURATION_WEEKS: {
    FULL: 6,
    SINGLE: 3
  }
} as const;

/**
 * Date format constants for display
 */
export const DATE_FORMATS = {
  FULL: 'MMMM d, yyyy',
  SHORT: 'MMM d, yyyy',
  ISO: 'yyyy-MM-dd',
  TIME: 'h:mm a'
} as const;